import _implicitStylesheets from "./filterPanel.css";
import _implicitScopedStylesheets from "./filterPanel.scoped.css?scoped=true";
import _aceFilterSearch from "ace/filterSearch";
import _aceFilterSection from "ace/filterSection";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="divider${0}" role="separator"${2}></div>`;
const stc0 = {
  classMap: {
    "container": true
  },
  key: 0
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, k: api_key, st: api_static_fragment, i: api_iterator, f: api_flatten, h: api_element} = $api;
  return [api_element("div", stc0, api_flatten([$cmp.searchable ? api_custom_element("ace-filter-search", _aceFilterSearch, {
    props: {
      "container": $cmp.container,
      "showfilters": $cmp.hasFilters
    },
    key: 1
  }) : null, api_iterator($cmp.options, function (itValue, itIndex, itFirst, itLast) {
    const it = {
      value: itValue,
      index: itIndex,
      first: itFirst,
      last: itLast
    };
    return [api_custom_element("ace-filter-section", _aceFilterSection, {
      props: {
        "container": $cmp.container,
        "section": it.value
      },
      key: api_key(2, it.value.key)
    }), !it.last ? api_static_fragment($fragment1, api_key(4, it.value.name)) : null];
  })]))];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-3r5qbs8oha0";
tmpl.legacyStylesheetToken = "undefined-_filterPanel";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
